import { CSV_EXTENSIONS_MAP } from '@app/src/common/constants/extentions';
import { GIGABYTE } from '@app/src/common/constants/common';

export enum GalleryOrderBy {
  AZ = 'name.asc',
  ZA = 'name.desc',
  LATEST = 'modifiedDate.desc',
  OLDEST = 'modifiedDate.asc'
}

export enum ContentView {
  TABLE,
  LIST
}

export const VIDEO_AGREEMENT_EXTENSIONS_MAP = new Map([
  ['.mp4', ['video/mp4']],
  ['.webm', ['video/webm']]
]);

export const VIDEO_EXTENSIONS_MAP = new Map([
  ['.avi', ['video/avi', 'video/x-msvideo', 'video/x-msvideo']],
  ['.mkv', ['video/x-matroska']],
  ['.mov', ['video/quicktime']],
  ['.mp4', ['video/mp4']],
  ['.mpeg', ['video/mpeg']],
  ['.webm', ['video/webm']],
  ['.wmv', ['video/x-ms-wmv']]
]);

export const IMAGE_EXTENSIONS_MAP = new Map([
  ['.bmp', ['image/bmp', 'image/x-windows-bmp']],
  ['.gif', ['image/gif']],
  ['.jpg', ['image/jpg', 'image/pjpeg']],
  ['.jpeg', ['image/jpeg', 'image/pjpeg']],
  ['.png', ['image/png']],
  ['.svg', ['image/svg+xml']]
]);

export const IMAGE_EXTENSIONS_MAP_LIGHT = new Map([
  ['.jpg', ['image/jpg', 'image/pjpeg']],
  ['.jpeg', ['image/jpeg', 'image/pjpeg']],
  ['.png', ['image/png']]
]);

export const POWERPOINT_EXTENSIONS_MAP = new Map([
  [
    '.ppt',
    [
      'application/mspowerpoint',
      'application/powerpoint',
      'application/vnd.ms-powerpoint',
      'application/x-mspowerpoint'
    ]
  ],
  [
    '.pptx',
    [
      'application/vnd.openxmlformats-officedocument.presentationml.presentation'
    ]
  ]
]);

export const DOCUMENT_EXTENSIONS_MAP = new Map([['.pdf', ['application/pdf']]]);

export const HTML_EXTENSIONS_MAP = new Map([['.html', ['text/html']]]);

export const AUDIO_EXTENSIONS_MAP = new Map([['.mp3', ['audio/mpeg']]]);

export const GALLERY_EXTENSIONS_MAP = new Map([
  ...VIDEO_EXTENSIONS_MAP,
  ...IMAGE_EXTENSIONS_MAP,
  ...POWERPOINT_EXTENSIONS_MAP,
  ...DOCUMENT_EXTENSIONS_MAP,
  ...AUDIO_EXTENSIONS_MAP,
  ...HTML_EXTENSIONS_MAP,
  ...CSV_EXTENSIONS_MAP
]);

export const SIZE_LIMIT = 4 * GIGABYTE;
